
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {get,post} from '../api'
export default {
components: {
TransferDom,
Popup,
Flexbox,
FlexboxItem,
Swiper,
SwiperItem,
XButton,
Group,
XInput,
XTextarea,
XHeader,
Cell,
Toast
},
methods: {

},
mounted() {
let tag = this.$route.query.tag;
if(this.GLOBAL.currentUser==undefined&&tag!='R'){
this.$router.push({ path: '/' });
}
let id=this.$route.query.id;

if(tag=='M'){
this.isManager=true;
this.isBusiness=false;
this.isRegedit=false;
}
else if(tag=='B'||tag=='A'){
this.isManager=false;
this.isBusiness=true;
this.isRegedit=false;
this.needAudit=false;
}
else if(tag=='R'){
this.isManager=false;
this.isBusiness=false;
this.isRegedit=true;
this.needAudit=false;
}
if(tag=='B'||tag=='A'){
this.businessDetail=this.GLOBAL.currentUser;
if(this.businessDetail.Status!=3){
this.needAudit=false;
}
}
else if(tag=='M'){
this.businessDetail=this.GLOBAL.currentObjs[id];
this.showCredential=true;
if(this.businessDetail.Status==1){
this.needAudit=false;
}
if(this.businessDetail.CredentialInfos!=null){
if(this.businessDetail.CredentialInfos.length==0){
this.imgUrl.push({
url: '/ShowImgPage?path=',//this.GLOBAL.noPicUrl,
img: this.GLOBAL.noPicUrl,
fallbackImg: this.GLOBAL.noPicUrl,
title: '暂无资质图片'});
}
else{
let index=1;
this.businessDetail.CredentialInfos.forEach(element => {
this.imgUrl.push({
url: '/ShowImgPage?path='+element.Path.replace("\\","/"),//process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
img: process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
fallbackImg: process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
title: '资质图片'+index
});
index++;
});
}
}
else{
this.imgUrl.push({
url: '/ShowImgPage?path=',//this.GLOBAL.noPicUrl,
img: this.GLOBAL.noPicUrl,
fallbackImg: this.GLOBAL.noPicUrl,
title: '暂无资质图片'});
}
}
},
methods: {

BusinessAction(tag){
if(tag==0){
this.businessDetail.Status=3;
post('/Business/update', this.businessDetail).then(response => {

if(response.code==1){
this.SuccessInfo='申请成功!';
this.showSuccess=true;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
else if(tag==1){

}
},

Audit(tag){
switch(tag){
case 0:
this.showReason=true;
break;
case 1:
this.businessDetail.ActionType=1;
this.businessDetail.Status=1;
post('/Business/update', this.businessDetail).then(response => {

if(response.code==1){
this.showSuccess=true;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
break;
case 2:
this.businessDetail.ActionType=1;
this.businessDetail.Status=0;
post('/Business/update', this.businessDetail).then(response => {

if(response.code==1){
this.showSuccess=true;
this.showReason=false;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
break;
}
},

Regedit(tag){
console.log('Regedit');
this.showSuccess=false;
this.showError=false;
this.showWarn=false;
if(tag==0){
this.$router.push({ path: '/LoginPage' });
}
else{

post('/Business/add', this.businessDetail).then(response => {

if(response.code==1){
this.showSuccess=true;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.data;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
},
getCredentialInfo(){
this.imgUrl.splice(0, this.imgUrl.length);
post('/attachinfo/query', {BGuid:this.businessDetail.BusinessGuid}).then(response => {

if(response.code==1){
if(response.data==null){
this.imgUrl.push({
url: '/ShowImgPage?path=',//this.GLOBAL.noPicUrl,
img: this.GLOBAL.noPicUrl,
fallbackImg: this.GLOBAL.noPicUrl,
title: '暂无资质图片'});
}
else{
let i=1;
response.data.forEach(element => {
this.imgUrl.push({
url: '/ShowImgPage?path='+element.Path.replace("\\","/"),//process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
img: process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
fallbackImg: process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
title: '资质图片'+i
});

i++;
});

}
}
else if(response.code==0){
this.showError=true;
this.showCredential=false;
}
else if(response.code==1001){
this.WarnInfo=response.data;
this.showWarn=true;
this.showCredential=false;
}
}).catch(error => {
console.log(error);
});
}
},
data () {
return {
businessDetail:{
BusinessName:'',
BusinessAddress:'',
Contactor:'',
TelNo:'',
Password:'',
Remark:''
},
imgUrl:[],
img_index:0,
isManager:true,
isBusiness:false,
isRegedit:true,
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'审核成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!',
showCredential:false,
needAudit:true,
showReason:false
}
}
}



// WEBPACK FOOTER //
// ./src/components/ManagerModules/BusinessDetail.vue